import { motion } from "framer-motion";
import { STATS } from "../../lib/content";

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative py-20 border-y border-[#D4AF37]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: "easeOut" }}
              data-testid={`stat-${i}`}
              className={`text-center lg:text-left ${i !== 0 ? "lg:border-l lg:border-[#D4AF37]/15 lg:pl-8" : ""}`}
            >
              <div className="font-serif-display text-[#D4AF37] text-4xl md:text-5xl tracking-tight">{s.value}</div>
              <div className="text-[#A3B1A8] text-sm mt-2 uppercase tracking-wider">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
